import script from "./FxNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./FxNotification.vue?vue&type=script&lang=ts&setup=true"

import "./FxNotification.vue?vue&type=style&index=0&id=675be2dc&lang=scss"

const __exports__ = script;

export default __exports__